import { render, staticRenderFns } from "./ClaimsSectionHeader.vue?vue&type=template&id=3ee499a5&"
import script from "./ClaimsSectionHeader.vue?vue&type=script&lang=js&"
export * from "./ClaimsSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports